<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="eventPricingMatricesNotFound">
  <h2>Pricing matrices not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4">

      <div class="alert" role="alert"
           [class.alert-success]="modalResult.status === CallbackResultStatus.success"
           *ngIf="modalResult !== null">
        {{ modalResult.text }}
      </div>

      <div class="alert" role="alert"
           [class.alert-success]="history.state.feedback.status == 'success'"
           [class.alert-info]="history.state.feedback.status == 'info'"
           *ngIf="history && history.state && history.state.feedback">
        {{ history.state.feedback.text }}
      </div>

      <div *ngIf="eventType && eventType.is_private_event_request_form"
           class="alert alert-info">
        This event type is a private event request form. Any payment collected via the pricing matrices configured below will be automatically applied to the private event.
        <div class="mt-2">
          The full list of participants often is not known at the time the request is submitted. Because of this, we recommend using per-booking fees for the request form pricing matrix.
        </div>
      </div>

      <ng-container *ngIf="!loadingEventPricingMatrices">
        <ng-container *ngIf="eventPricingMatrices.length > 0">
          <div *ngFor="let matrix of eventPricingMatrices">
            <p>Pricing Matrix Name: <b>{{ matrix.name }}</b></p>

            <div class="row">
              <div class="col-md-10 col-lg-8 col-xl-6">
                <app-event-type-pricing-matrix-details [matrix]="matrix"></app-event-type-pricing-matrix-details>
              </div>
            </div>

            <p *ngIf="eventType?.schedule_type === ScheduleType.oneOff">
              <b>Private event check-in before final payment:</b>
              {{ matrix.allow_check_in_before_final_payment ? 'Allowed' : 'Not allowed' }}
            </p>

            <div>
              <a href="#" class="btn btn-sm btn-primary mr-2"
                 [routerLink]="['/events/setup/edit/' + eventType?.id + '/pricing-matrices/' + matrix.id.toString()]">
                Edit Matrix
              </a>
              <button class="btn btn-sm btn-danger"
                      (click)="openRemoveMatrixModal(matrix)">
                Remove Matrix
              </button>
            </div>

            <hr>
          </div>
        </ng-container>

        <div class="alert alert-info" role="alert" *ngIf="eventPricingMatrices.length === 0">
          This event type has no pricing matrices.
        </div>

        <a href="#" class="btn btn-primary btn-sm mb-3"
           [routerLink]="['/events/setup/edit/' + eventType?.id + '/pricing-matrices/add']">
          Add Pricing Matrix
        </a>
      </ng-container>

      <div class="alert alert-info" role="alert" *ngIf="loadingEventPricingMatrices">
        Loading pricing matrices...
      </div>

      <div>
        <div class="float-right">
          <button class="btn btn-primary"
                  routerLink="/events/setup/edit/{{ eventType ? eventType.id : '' }}/schedules"
                  [disabled]="isLoading()" [class.disabled]="isLoading()">
            Continue
          </button>
        </div>
        <button [routerLink]="['/events/setup/event-types']"
                [queryParams]="{status: eventType?.status}"
                class="btn btn-secondary"
                [disabled]="isLoading()" [class.disabled]="isLoading()">
          Back
        </button>
      </div>

    </div>

  </div>

</div>
